'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _class = function () {
	/*@ngInject*/
	function _class($http, $filter, ColorFinder, DateFinder, ValidIndexes) {
		_classCallCheck(this, _class);

		this.$http = $http;
		this.$filter = $filter;
		this.ColorFinder = ColorFinder;
		this.DateFinder = DateFinder;
		this.ValidIndexes = ValidIndexes;
	}

	_createClass(_class, [{
		key: '$onInit',
		value: function $onInit() {
			var _this = this;

			this.$http.get('/api/students').then(function (response) {
				_this.students = response.data;
			});

			this.$http.get('/api/icons').then(function (response) {
				_this.icons = response.data[0] || {
					first: '',
					second: '',
					third: '',
					fourth: '',
					fifth: '',
					sixth: '',
					year12: '',
					_note: '',
					_tempUnknown: '',
					_permUnknown: '',
					_perm2Unknown: ''

				};
			});

			this.$http.get('/api/termsettings').then(function (response) {
				if (response && response.data && response.data[0]) {
					console.log(response.data[0]);
					_this.term = {
						_id: response.data[0]._id,
						termNo: response.data[0].termNo,
						startDate: Date.parse(response.data[0].startDate),
						endDate: Date.parse(response.data[0].endDate),
						sixthSunday: response.data[0].sixthSunday
					};
				} else {
					_this.term = {
						termNo: '',
						startDate: '',
						endDate: '',
						sixthSunday: ''
					};
				}
			});
			this.$http.get('/api/lessons').then(function (response) {
				_this.sessions = response.data;
			});

			this.$http.get('/api/smssettings').then(function (response) {
				_this.smssettings = response.data[0] || {
					mobileNumber1: '',
					mobileNumber2: '',
					mobileNumber3: ''

				};
			});

			this.isSandbox = location.hostname.includes('sandbox');
			this.loading = false;
		}
	}, {
		key: 'resetDatabase',
		value: function resetDatabase() {
			if (confirm('Are you sure you want to refresh the database?')) {
				this.$http.get('/api/users/new-database');
			}
		}
	}, {
		key: 'addYear',
		value: function addYear() {
			var _this2 = this;

			if (confirm('Are you sure you want to do this?')) {
				this.students.forEach(function (student) {
					if (!student.isTertiary) {
						if (student.grade == 12) {
							student.isTertiary = true;
							student.isActive = false;
						} else {
							student.grade++;
						}

						_this2.$http.put('/api/students/' + String(student._id), student);
					}
				});
			}
		}
	}, {
		key: 'saveIcons',
		value: function saveIcons() {
			var _this3 = this;

			this.success = false;
			this.fail = false;
			if (this.icons._id) {
				this.$http.put('/api/icons/' + String(this.icons._id), this.icons).then(function (res) {
					_this3.success = true;
				}).catch(function (res) {
					_this3.fail = true;
				});
			} else {
				this.$http.post('/api/icons', this.icons).then(function (res) {
					_this3.success = true;
				}).catch(function (res) {
					_this3.fail = true;
				});
			}
		}
	}, {
		key: 'updateSettings',
		value: function updateSettings() {
			var _this4 = this;

			this.success = false;
			this.fail = false;

			if (this.term._id) {
				this.$http.put('/api/termsettings/' + String(this.term._id), this.term).then(function (res) {
					_this4.term.success = true;
				}).catch(function (res) {
					_this4.term.fail = true;
				});
			} else {
				this.$http.post('/api/termsettings', this.term).then(function (res) {
					_this4.term.success = true;
				}).catch(function (res) {
					_this4.term.fail = true;
				});
			}

			getWeekendsOfTerm();
		}
	}, {
		key: 'updateSMSSettings',
		value: function updateSMSSettings() {
			var _this5 = this;

			this.success = false;
			this.fail = false;

			if (this.smssettings._id) {
				this.$http.put('/api/smssettings/' + String(this.smssettings._id), this.smssettings).then(function (res) {
					_this5.smssettings.success = true;
				}).catch(function (res) {
					_this5.smssettings.fail = true;
				});
			} else {
				this.$http.post('/api/smssettings', this.smssettings).then(function (res) {
					_this5.smssettings.success = true;
				}).catch(function (res) {
					_this5.smssettings.fail = true;
				});
			}
		}
	}, {
		key: 'generateEmails',
		value: function generateEmails() {
			var _this6 = this;

			if (confirm('Are you sure you want to send student e-mails?')) {
				this.loading = true;
				var start = new Date(this.term.startDate);
				var end = new Date(this.term.endDate);
				var termNo = this.term.termNo;
				var sixthSunday = this.term.sixthSunday;
				var studentIds = this.getStudentIds();

				var studentSessions = this.sessions.filter(function (session) {
					return studentIds.has(session.clientUID);
				});

				var sessionData = [];
				studentSessions.forEach(function (session) {
					var validIndexes = _this6.ValidIndexes(session, start, end);
					validIndexes.forEach(function (index) {

						var sessionDate = _this6.DateFinder(session, index);
						var formattedDate = _this6.$filter('toDateString')(sessionDate);
						var parsedDate = _this6.$filter('reparseDate')(formattedDate);
						var color = _this6.ColorFinder(session, index);
						sessionData.push({
							clientUID: session.clientUID,
							duration: session.duration / 60,
							sessionDate: sessionDate,
							date: parsedDate,
							color: color
						});
					});
				});

				sessionData = sessionData.filter(function (session) {
					var acceptedColors = ['blue', 'dark blue', 'green', 'dark green', 'purple', 'dark purple'];
					var color = session.color.toLowerCase();
					return acceptedColors.includes(color);
				});

				sessionData = sessionData.sort(function (a, b) {
					if (a.sessionDate < b.sessionDate) {
						return -1;
					}

					if (a.sessionDate > b.sessionDate) {
						return 1;
					}

					if (a.basicTime < b.basicTime) {
						return -1;
					}

					if (a.basicTime > b.basicTime) {
						return 1;
					}

					return 0;
				});

				console.log(sessionData.length);
				var studentsData = [];
				var weekEnderResults = this.getWeekendsOfTerm();
				studentIds.forEach(function (sID) {
					var sessionsForStudent = sessionData.filter(function (session) {
						return session.clientUID == sID;
					});
					var weekListInfo = _this6.retrieveHoursPerWeek(weekEnderResults, sessionsForStudent);
					var student = _this6.students.find(function (s) {
						return s._id == sID;
					});
					studentsData.push({
						clientEmailAddress: student.clientEmail.toLowerCase(),
						clientName: student.clientFirstName,
						studentName: student.firstName,
						termNo: termNo,
						sixthSunday: sixthSunday,
						hoursCompleted: weekListInfo.hoursCompleted,
						hoursToFinish: 10 - weekListInfo.hoursCompleted,
						weekList: weekListInfo.weekList
					});
				});

				studentsData = studentsData.filter(function (s) {
					return s.clientEmailAddress != "contact@gspt.com.au";
				}).sort(function (a, b) {
					if (a.clientEmailAddress < b.clientEmailAddress) {
						return -1;
					}

					if (a.clientEmailAddress > b.clientEmailAddress) {
						return 1;
					}
					return 0;
				});
				console.log(studentsData);

				this.$http.post('/api/students/send-email-notif', {
					subject: 'Tuition Schedule to Finish Term ' + termNo,
					studentInfo: studentsData
				}).then(function () {
					return console.log("success");
				}, function () {
					return console.log("error");
				});

				console.log("reached end of generate emails");
			}
			this.loading = false;
		}
	}, {
		key: 'retrieveHoursPerWeek',
		value: function retrieveHoursPerWeek(weekEnderResults, sessionData) {
			var hoursCompleted = 0;
			var weekListInfo = {
				hoursCompleted: 0,
				weekList: []
			};

			weekEnderResults.forEach(function (weekend, i, weekends) {
				var weekendDate = new Date(weekend.value);
				weekend.duration = 0;
				sessionData.forEach(function (session) {
					var sessionDate = new Date(session.date);
					if (i == 0 && sessionDate <= weekendDate) {
						weekend.duration += session.duration;
					} else if (i > 0) {
						var weekendStart = new Date(weekends[i - 1].value);
						if (sessionDate >= weekendStart && sessionDate <= weekendDate) {
							weekend.duration += session.duration;
						}
					}
				});

				var month = ("0" + (weekendDate.getMonth() + 1)).slice(-2);
				var date = ("0" + weekendDate.getDate()).slice(-2);

				var status = i > 4 ? 'Scheduled' : 'Completed';
				var toBeRescheduled = false;
				if (i >= 0 && i <= 4) {
					weekListInfo.hoursCompleted += weekend.duration;
					if (weekend.duration == 0) {
						status += " (To Be Rescheduled)";
						toBeRescheduled = true;
					}
				} else if (i == 9) {
					status += '  (Does This Session Need To Be Rescheduled?)';
				}
				weekListInfo.weekList.push({
					value: 'Week Ending ' + date + '/' + month + ' - ' + weekend.duration + ' Hour ' + status,
					toBeRescheduled: toBeRescheduled
				});
			});
			return weekListInfo;
		}
	}, {
		key: 'getStudentIds',
		value: function getStudentIds() {
			var _this7 = this;

			var weekEnderResults = this.getWeekendsOfTerm();

			var start = new Date(weekEnderResults[4].value);
			start.setDate(start.getDate() + 1);
			var end = new Date(weekEnderResults[5].value);

			console.log("Start date:" + start);
			console.log("End date" + end);

			var studentIds = [];

			var sessions = this.sessions.map(function (session) {
				if (!session.student && session.clientUID) {
					session.student = _this7.students.find(function (s) {
						return s._id === session.clientUID;
					});
				}
				return session;
			});
			sessions.forEach(function (session) {
				var validIndexes = _this7.ValidIndexes(session, start, end);

				validIndexes.forEach(function (index) {
					var sessionDate = _this7.DateFinder(session, index);
					var formattedDate = _this7.$filter('toDateString')(sessionDate);
					var parsedDate = _this7.$filter('reparseDate')(formattedDate);
					var color = _this7.ColorFinder(session, index);
					studentIds.push(session.clientUID);
				});
			});

			studentIds = new Set(studentIds.sort());
			var studentEmailInfo = [];
			studentIds.forEach(function (studentId) {
				var student = _this7.students.find(function (s) {
					return s._id == studentId;
				});
				studentEmailInfo.push({
					clientEmailAddress: student.clientEmail,
					clientName: student.clientFirstName,
					studentName: student.firstName
				});
			});

			return studentIds;
		}
	}, {
		key: 'getWeekendsOfTerm',
		value: function getWeekendsOfTerm() {
			var start = new Date(this.term.startDate);
			var end = new Date(this.term.endDate);
			var weekEnderResults = [];
			var day = 0;
			var current = new Date(start);

			current.setDate(current.getDate() + (day - current.getDay() + 7) % 7);
			end.setDate(end.getDate() + (7 - end.getDay()) % 7);

			while (current <= end) {
				var weekEnder = new Date(+current);
				weekEnderResults.push({
					value: weekEnder,
					duration: 0
				});
				current.setDate(current.getDate() + 7);
			}

			return weekEnderResults;
		}
	}]);

	return _class;
}();

exports.default = _class;


// WEBPACK FOOTER //
// ./client/app/admin/settings/settings.controller.js